import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';
import { loadZonesFailed, loadZonesSuccessful, setServerTimeZoneSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import processError from '../../../utils/processError';

export default function* loadZones(action) {
  try {
    const url = `${BACKEND_URL}/hosts/zones`;
    const pool = {};
    const userDataResponse = yield makeRequest(url, pool, action, 'POST');
    const responseJson = yield userDataResponse.json();
    if (userDataResponse && userDataResponse.status === OK && responseJson.result) {
      const res = responseJson.result;
      yield put(loadZonesSuccessful(res));
      yield put(setServerTimeZoneSuccessful(res.meta && res.meta.server_timezone ? res.meta.server_timezone : 'Europe/Moscow'));
      yield call(resolveActionPromise(action, responseJson.result));
    } else {
      yield put(loadZonesFailed(responseJson));
      yield call(rejectActionPromise(action, responseJson));
    }
  } catch (e) {
    yield put(loadZonesFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
